import React from 'react'
import Breadcrumbs from 'utils/Breadcrumbs'

const BreadcrumbsBlock = ({ blok }) => {
    return (
        <div className="bg-white">
            <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
                <div className="text-center">
                    <Breadcrumbs/>
                </div>
            </div>
        </div>
    )
}

export default BreadcrumbsBlock